module.exports = __webpack_public_path__ + "static/media/audit_report.fe7fdb47.pdf";